import { Injectable } from '@angular/core';
import { createFeatureSelector, createSelector, Store } from '@ngrx/store';
import { expensesFeatureStoreKey } from '../feature/expenses.feature';
import { InitExpensesState } from '../state/expenses.state';

export const getInitExpensesState = createFeatureSelector<InitExpensesState>(
  expensesFeatureStoreKey,
);

export const getExpenseShareTypes = createSelector(
  getInitExpensesState,
  (state) => state?.expenseShareTypes,
);

export const getAllocationTableData = createSelector(
  getInitExpensesState,
  (state) => {
    return state.allocatedExpenses;
  },
);

export const getIsNewExpenseSubmitProcessing = createSelector(
  getInitExpensesState,
  (state) => state.isNewExpenseSubmitProcessing,
);

export const getUpdateExpenseSubmitProcessing = createSelector(
  getInitExpensesState,
  (state) => state.updateExpenseSubmitProcessing,
);

export const getDeleteExpenseSubmitProcessing = createSelector(
  getInitExpensesState,
  (state) => state.deleteExpenseSubmitProcessing,
);

export const getExpenses = createSelector(getInitExpensesState, (state) => {
  return state.expenses;
});

export const getExpensesRequestStatus = createSelector(
  getInitExpensesState,
  (state) => state.expensesRequestStatus,
);

export const getSelectedExpense = createSelector(
  getInitExpensesState,
  (state) => state.selectedExpense,
);

export const getSelectedUserExpenses = createSelector(
  getInitExpensesState,
  (state) => state.selectedUserExpenses,
);

export const getSelectedUserExpensesRequestStatus = createSelector(
  getInitExpensesState,
  (state) => state.selectedUserExpensesRequestStatus,
);

export const getSelectedUserExpense = createSelector(
  getInitExpensesState,
  (state) => state.selectedUserExpense,
);

@Injectable({
  providedIn: 'root',
})
export class ExpensesSelectors {
  getExpenseShareTypes$ = this.store.select(getExpenseShareTypes);
  getAllocationTableData$ = this.store.select(getAllocationTableData);
  getIsNewExpenseSubmitProcessing$ = this.store.select(
    getIsNewExpenseSubmitProcessing,
  );
  getUpdateExpenseSubmitProcessing$ = this.store.select(
    getUpdateExpenseSubmitProcessing,
  );
  getDeleteExpenseSubmitProcessing$ = this.store.select(
    getDeleteExpenseSubmitProcessing,
  );
  getExpenses$ = this.store.select(getExpenses);
  getExpensesRequestStatus$ = this.store.select(getExpensesRequestStatus);
  getSelectedExpense$ = this.store.select(getSelectedExpense);
  getSelectedUserExpenses$ = this.store.select(getSelectedUserExpenses);
  getSelectedUserExpensesRequestStatus$ = this.store.select(
    getSelectedUserExpensesRequestStatus,
  );
  getSelectedUserExpense$ = this.store.select(getSelectedUserExpense);

  constructor(private store: Store<InitExpensesState>) {}
}
